var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{staticClass:"px-1 mb-2",attrs:{"cols":"6","md":"4"}},[_c('b-row',{staticClass:"no-gutters border rounded h-49 d-flex align-items-center justify-content-center"},[_c('b-link',{attrs:{"href":_vm.getBrokerUrl,"title":"Broker Link","target":"_blank"},on:{"click":_vm.onClick}},[_vm._t("broker-image")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }